import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Очистка кеша при запуске приложения
if ('caches' in window) {
  console.log('Очистка кеша приложения...');
  caches.keys().then((names) => {
    names.forEach(name => {
      console.log(`Удаление кеша: ${name}`);
      caches.delete(name);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 